module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0134.jpg?v=66f1910d";